import {
    ISimulationCalculatorCalculateOptions,
    ISimulationCalculatorCalculateResults,
} from "../PA.Simulation.Core/PA.Simulation.IF.Aspects";
import { ISimulationCalculator, ISimulationServiceResponse } from "../PA.Simulation.Services/SimulationServices.IF";
import { MessageProvider } from "../PA.Core/Basic/Messages";
import { ProgressProvider } from "../PA.Core/Basic/Progress";
import { SimulationBO } from "../PA.Simulation.BusinessObjects/SimulationBO";
import { BehaviorSubject } from "rxjs";
import * as _ from "lodash";
import { ASync } from "../PA.Core/Basic/ASync";
import { IMessageProvider, IProgressProvider, MessageType } from "../PA.Core/PA.Core.IF.Basic";
import { SimulationService } from "./SimulationService";
import { DateUtils } from "../PA.Core/Basic/Dates";
import { esWB_Simulation } from "../PA.Core/PAdbSchema";
import { PAEnvironment } from "../PA.Core/PAEnvironment";

export class SimulationCalculator implements ISimulationCalculator {
    private _calcMessageProvider: MessageProvider;
    private _calcProgressProvider: ProgressProvider;
    private _calcComplete: BehaviorSubject<SimulationCalculator>;
    private _simulationBO: SimulationBO;

    private _bIsLoaded: boolean;

    //   private _CalculateCompleteSubscription: Subscription
    constructor(aBO: SimulationBO) {
        this._calcMessageProvider = new MessageProvider();
        this._calcProgressProvider = new ProgressProvider();
        this._calcComplete = new BehaviorSubject<SimulationCalculator>(this);
        this._simulationBO = aBO;
        this._bIsLoaded = false;
    }

    Register(SimulationBO: SimulationBO): void {
        const self = this;
        const bo = SimulationBO;
        // Currently, we don't listen to anything,.. just on demand calc.

        this.UnRegister();
        this._simulationBO = SimulationBO;

        if (bo) {
            bo.OnLoadComplete.then((result) => {
                return ASync.resolve();
            })
                .then((ignore) => {
                    // Subscribe
                    self._bIsLoaded = true;
                })
                .catch((err) => {
                    console.log("Error in Simulation Evaluator Register(): ", err);
                    self._bIsLoaded = false;
                });
        }
    }

    UnRegister(): void {
        this._simulationBO = undefined;
        this._bIsLoaded = false;
    }

    private get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }

    get CalcProgressProvider(): IProgressProvider {
        return this._calcProgressProvider;
    }

    get CalcMessageProvider(): IMessageProvider {
        return this._calcMessageProvider;
    }

    get OnCalculateComplete(): BehaviorSubject<SimulationCalculator> {
        return this._calcComplete;
    }

    async Calculate(opts: ISimulationCalculatorCalculateOptions): Promise<ISimulationCalculatorCalculateResults> {
        const self = this;
        const usrContext = PAEnvironment.getValue(PAEnvironment.UserContext);
        const aBO: SimulationBO = self._simulationBO;
        if (_.isEmpty(aBO)) {
            return;
        }

        try {
            self.CalcMessageProvider.clearMessages();
            self.CalcProgressProvider.start("Calculating Simulation");
            self.CalcProgressProvider.setProgressMessage("Saving", "Validating and Saving Simulation");
            const retVal: ISimulationCalculatorCalculateResults = {
                GUID: "", //no need to popualte for the response object here
                bSuccess: true,
                results: undefined,
                sErrors: [],
                sWarnings: [],
            };

            // 1. Update Prices and Save (Validate)
            const aSimulationService = new SimulationService();
            try {
                await aBO.updatePricing();
            } catch (err) {
                retVal.sErrors.push(err.message);
            }
            aBO.drWB_Simulation.WB_UserRow_CreatedBy = usrContext.User;
            await aBO.Save();

            if (!aBO.bIsSaved) {
                self.CalcProgressProvider.setProgressMessage("Saving", "Unable to Save Simulation to Calculate");
                self.CalcProgressProvider.finish();
                return;
            }

            // 2. Run Simulation Evaluator
            self.CalcProgressProvider.setProgressMessage("Calculating", "Calculating Simulation");

            const results = await aSimulationService.CalculatePromotionSimulation(
                aBO.WB_Simulation.cif.WB_SIMULATION_ID,
                {},
            );

            if (results.bSuccess) {
                self.CalcMessageProvider.addMessage({
                    code: "Success",
                    type: MessageType.Information,
                    title: "Calculation Completed",
                    description: "Calculating Completed",
                });
            } else {
                self.CalcMessageProvider.addMessage({
                    code: "Failed",
                    type: MessageType.Information,
                    title: "Calculating Failed with Error",
                    description: results.results,
                });
            }
            // Add Any Warnings
            self._calcMessageProvider.addTextMessages("CalcW", MessageType.Warning, results.sWarnings);
            // Add Any Errors
            self._calcMessageProvider.addTextMessages("CalcE", MessageType.Error, results.sErrors);

            self.CalcProgressProvider.finish();

            //Update Last Calced Date
            aBO.drWB_Simulation.cif.LAST_CALC_DTTS = DateUtils.convertToSAPBWTs(new Date());
            await aBO.dbContext.Save(esWB_Simulation, aBO.drWB_Simulation);

            await aBO.OnLoadSummary();
            await aBO.ReloadMetrics();

            self.OnCalculateComplete.next(self);
            retVal.results = results.results;
            retVal.sErrors.push(...results.sErrors);
            retVal.sWarnings.push(...results.sWarnings);
            retVal.bSuccess = retVal.sErrors.length === 0;
            return retVal;
        } catch (err) {
            self.CalcProgressProvider.exception(err);
            throw err;
        }
    }
}
